import { Box, IconButton, styled } from '@material-ui/core';

// Remove ("×") control — light-red circle + red icon on hover.
export const RemoveBtn = styled(IconButton)({
  '&:hover': {
    backgroundColor: '#FDE7E7',
    color: '#FA2020'
  }
});

// Removed-slot variant styling is applied inline by the component (MUI v4
// styled has no custom-prop generic).
export const AltCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  border: 'none',
  borderRadius: 12,
  padding: '8px 10px',
  background: '#F5F7F9'
});

export const Eyebrow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10
});

// Compact Active / Stocked status chip — the alternate-only variant of
// `ProductStatusBadge`. Same look as the Top card's badge but with tighter
// padding and a smaller label so the header row doesn't gap out.
export const AltStatusBadge = styled(Box)({
  minWidth: 'fit-content',
  padding: '3px 10px',
  borderRadius: 14,
  border: '1px solid #AFBAC6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#5D7083',
  '& p': {
    fontWeight: 700,
    fontSize: 11,
    lineHeight: 1.5,
    color: '#5D7083'
  }
});

export const SlotLabel = styled('span')({
  fontSize: 11,
  fontWeight: 700,
  color: '#5d7083',
  textTransform: 'uppercase'
});

export const ControlBtn = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  height: 28,
  padding: '0 10px',
  borderRadius: 999,
  border: '1px solid #E0E0E0',
  background: '#fff',
  color: '#5D7083',
  fontSize: 11.5,
  fontWeight: 600,
  fontFamily: 'inherit',
  cursor: 'pointer',
  '&:hover': { background: '#F7F8FA', color: '#333D47' }
});
